import { useQuery, useQueryClient } from "@tanstack/react-query";
import { PurchaseOrderService } from "src/services";
import { QueryParamsMapper } from "src/mappers/queryParamsMapper";
import { queryKeys } from "src/constants";
import { PurchaseOrderPaginationOptions } from "src/types";

interface UsePurchaseOrdersForEuRelabelOptions {
  enabled?: boolean;
}

const usePurchaseOrdersForEuRelabel = (
  purchaseOrderService: PurchaseOrderService,
  paginationOptions: PurchaseOrderPaginationOptions = {},
  options: UsePurchaseOrdersForEuRelabelOptions = {}
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getPurchaseOrdersForEuRelabelQueryParams(paginationOptions);

  const {
    data: paginatedPurchaseOrders,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedPurchaseOrdersForEuRelabel(queryParams),
    queryFn: () => purchaseOrderService.getPurchaseOrdersForEuRelabel(queryParams),
    enabled: options.enabled ?? true
  });

  const refreshPurchaseOrders = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedPurchaseOrdersForEuRelabel(),
      exact: false
    });
  };

  return { paginatedPurchaseOrders, fetchError, isLoading, refreshPurchaseOrders };
};

export { usePurchaseOrdersForEuRelabel };
